import { Component } from '@angular/core';

@Component({
  selector: 'about-irrigation',
  templateUrl: 'about-irrigation.html'
})
export class AboutIrrigationPage {
  constructor() {}
}




// WEBPACK FOOTER //
// ./src/pages/about-irrigation/about-irrigation.ts